// extracted by mini-css-extract-plugin
export default {"progress":"ProgressCircle_progress__HOSFu","progress__info":"ProgressCircle_progress__info__BTs2S"};